{
  "REGISTER": {
    "TRY_WOOT": "Crear una cuenta",
    "TITLE": "Registrarse",
    "TESTIMONIAL_HEADER": "Todo lo que se necesita es un paso adelante",
    "TESTIMONIAL_CONTENT": "Usted está a un paso de involucrar a sus clientes, conservarlos y encontrar nuevos.",
    "TERMS_ACCEPT": "Al crear una cuenta, aceptas nuestros <a href=\"https://chat.jarabot.com/terms\">Términos y condiciones</a> y nuestra <a href=\"https://chat.jarabot.com/privacy-policy\">Política de privacidad</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Registrarse con Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Nombre de la empresa",
      "PLACEHOLDER": "Introduce el nombre de tu empresa, por ejemplo: Wayne Enterprises",
      "ERROR": "El nombre de la cuenta es demasiado corto"
    },
    "FULL_NAME": {
      "LABEL": "Nombre completo",
      "PLACEHOLDER": "Introduce tu nombre completo, por ejemplo: Bruce Wayne",
      "ERROR": "El nombre completo es demasiado corto"
    },
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "Introduzca su dirección de correo electrónico de trabajo. Por ejemplo, bruce{'@'}wayne{'.'}empresas",
      "ERROR": "Por favor, introduzca una dirección de correo válida"
    },
    "PASSWORD": {
      "LABEL": "Contraseña",
      "PLACEHOLDER": "Contraseña",
      "ERROR": "La contraseña es demasiado corta",
      "IS_INVALID_PASSWORD": "La contraseña debe contener al menos 1 letra mayúscula, 1 letra minúscula, 1 número y 1 carácter especial"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirmar contraseña",
      "PLACEHOLDER": "Confirmar contraseña",
      "ERROR": "La contraseña no coincide"
    },
    "API": {
      "SUCCESS_MESSAGE": "Registro Exitoso",
      "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
    },
    "SUBMIT": "Crear una cuenta",
    "HAVE_AN_ACCOUNT": "¿Ya tienes una cuenta?",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Términos y condiciones</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Política de privacidad</a>"
  }
}
